import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { fnum } from '../../utils/utils'

export default class OrderListItem extends React.Component {
  onclick = e => {
    e.preventDefault();
    this.context.router.push('/order/edit?id='+this.props.data.order_id);
  }

  render() {
    const containerStyle = {
      backgroundColor: this.props.stts.stts_color_id,
      fontWeight:'bold'
    }
    const { empls, data } = this.props;
    const debit = data.p1_balance;
    const credit = data.p2_balance;
    const sum = data.p1_srvcsum;
    const note = data.order_note.toString().length>0 ? '('+data.order_note+')' : '';
    const desc = data.order_desc.toString().length>0 ? data.order_desc : 'Без названия';
    const manager2 = empls.find(el => el.user_id === data.order_empl2);
    const manager = manager2 ? manager2.user_fname.slice(0, 9) : '';

    return (
      <tr onClick={this.onclick}>
        <td style={containerStyle}>
          {data.order_num}
        </td>
        <td>{this.props.comp.comp_desc}</td>
        <td>{desc}{" "}{note}</td>
        <td>{manager}</td>
        <td>{moment(data.order_edate).format('L')}</td>
        <td className="text-right">{fnum(sum)}</td>
        <td className="text-right">{fnum(debit)}</td>
        <td className="text-right">{fnum(credit)}</td>
      </tr>
    )

  }
}

OrderListItem.contextTypes = {
  router: PropTypes.object.isRequired
}



// WEBPACK FOOTER //
// ./src/components/order/OrderListItem.js